/* eslint-disable camelcase */
import { ServiceType } from './ServicePresets';
import { ServiceCardIconType } from './Common';

export interface IUserConnectedServices {
  union_accounts: UnionAccount[] | null;
  internet_accounts: InternetAccount[] | null;
  iptv_accounts: IptvAccount[] | null;
  ctv_accounts: CtvAccount[] | null;
}

export interface IUserAvailableServices {
  types: AvailableServiceTypes[];
}

export interface AvailableServiceTypes {
  Name: string;
  TypeId: number;
  id: number;
  Services: Service[];
}

export interface ChangeServiceTypes {
  Name: string;
  TypeId: number;
  id: number;
  isActive: boolean;
  Services: ServiceChange[];
}

export interface Account {
  id: number;
  Status: string;
  StatusID: number;
  ExpireDate: Date;
  RealExpireDate: Date;
  IsDisabled: boolean;
  LoyaltyProgram?: LoyaltyProgram | null;
  DisableReason: string;
  CreateDate: Date;
  Service: Service;
  ServicesEx?: ServiceEx[];
  ConnectionType?: string;
  ConnectionProtocol?: ConnectionProtocol;
}

export interface UnionAccount extends Account {
  Internet: InternetAccount | null;
  Iptv: IptvAccount | null;
  Ctv: CtvAccount | null;
}

export interface CtvAccount extends Account {
  Access: AccessPoint;
}

export interface InternetAccount extends Account {
  Access: AccessPoint;
  DedicatedIP: string;
}

export interface IptvAccount extends Account {
  BrizTV: BrizTV | null;
  Devices: Devices[];
}

export interface BrizTV {
  Email: string;
  Phone: string;
  Password: string;
}

export interface AccessPoint {
  id: number;
  MAC: string;
  IP: string;
  Login: string;
  Type: string;
  TypeID: number;
  Password: string;
}

export interface Devices extends AccessPoint {
  IsLinked: boolean;
}

export interface Service {
  id: number;
  Name: string;
  Price: number;
  IsOnce: boolean;
  IsBonusPaymentAllowed: boolean;
  IsGigabitRouterRequired: boolean;
  Description: string;
  Daily: boolean;
  Hidden: boolean;
  Monthly: boolean;
  Type?: ServiceType;
  Share?: ServiceShare | null;
  AnalyticsID: string | null;
  InetServiceID: number;
  IptvServiceID: number;
  isAllowUserChange?: boolean;
  Tags: ServiceTag[];
  TransitionToBrizTVServiceID?: number;
}

export interface ServiceShare {
  id: number;
  Name: string;
  StopDate?: string;
  CanSuspend: boolean;
}

interface ServiceChange extends Service {
  isAvailableForConnection: boolean;
  icon: ServiceCardIconType;
  isCurrent: boolean;
  isPrepaid: boolean;
  isCashback: boolean;
}

export interface ServiceEx extends Service {
  LimitedForServices?: Array<number>;
}

interface ServiceTag {
  id: ServiceTags;
  Name: string;
}

export enum ServiceTags {
  Suspension = 1,
}

export enum ServicesTypes {
  INTERNET_WITH_IPTV = 1,
  INTERNET_TV = 2,
  INTERNET = 3,
  INTERNET_DAILY = 4,
  INTERNET_TV_MAX = 5,
}

export interface LoyaltyProgram {
  Name: string;
  FromDate: string;
  ToDate: string;
}

interface ConnectionProtocol {
  id: number;
  Name: string;
}

export enum ConnectionProtocolTypes {
  Default = 0,
  IPoE = 1,
  PPPoE = 2,
}

export enum AllocationType {
  FLAT = 1,
  PRIVATE_HOUSE = 2,
  SEPARATE_BUILDING = 3,
  OFFICE = 4,
}
